import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listEvents, listPosts, listTeamMembers, listMembers, listPartners } from "../../api/cms";

const entities = [
  { label: "Events", path: "/admin/events", loader: listEvents },
  { label: "Posts", path: "/admin/posts", loader: listPosts },
  { label: "Team members", path: "/admin/team-members", loader: listTeamMembers },
  { label: "Members", path: "/admin/members", loader: listMembers },
  { label: "Partners", path: "/admin/partners", loader: listPartners },
];

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    entities.forEach(({ label, loader }) => {
      loader()
        .then((items) => setCounts((c) => ({ ...c, [label]: items.length })))
        .catch(() => setCounts((c) => ({ ...c, [label]: "—" })));
    });
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {entities.map(({ label, path }) => (
          <Link
            key={label}
            to={path}
            className="bg-white rounded-lg shadow p-5 hover:shadow-md transition-shadow"
          >
            <div className="text-3xl font-bold text-bahyellow">
              {counts[label] ?? "…"}
            </div>
            <div className="text-sm text-gray-600 mt-1">{label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
